<template>
  <Loading
    v-if="composable.loading.setting.isShow"
    :content="composable.loading.setting.content"
  />

  <div
    v-if="page === 'signUp'"
    class="page"
  >
    <Header
      :setting="{
        title: '申請帳號',
        hasCancelMethod: false,
      }"
    />
    <div class="page__form mv8">
      <input
        v-model.trim="memberInfo.twid"
        type="text"
        placeholder="身份證/Resident ID No."
        class="mb5"
      >
      <input
        v-model.trim="memberInfo.birthdate"
        type="text"
        placeholder="西元生日/Birth Date(YYYYMMDD)"
        class="mb5"
      >
      <input
        v-model.trim="memberInfo.mobile"
        type="text"
        placeholder="手機號碼/Mobile"
        class="mb5"
      >
      <input
        v-model="memberInfo.password"
        type="password"
        placeholder="密碼/Password"
        class="mb5"
      >
      <div class="page__input--with-button mb5">
        <input
          v-model="memberInfo.bindingCode"
          type="text"
          placeholder="驗證碼/SMS"
        >
        <div
          v-if="countDownSeconds === 0"
          @click="sendBindingCode"
          class="label label--primary column--central"
        >
          發送驗證碼
        </div>
        <div
          v-else
          class="label label--disable column--central"
        >
          請等候 {{ countDownSeconds }} 秒
        </div>
      </div>
    </div>
    <div
      @click="verifyMemberShip"
      class="label label--primary"
    >
      送出申請
    </div>
  </div>

  <Death
    v-else
    :message="composable.death.message"
    :page="page"
  />

  <Modal
    v-if="composable.modal.setting.isShow"
    :setting="composable.modal.setting"
    @close="composable.modal.close"
    @toLogin="toLogin"
  />
</template>

<script>
import { reactive, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import composable from '@/composable/index';
import api from '@/api/index';
import spiderman from '@/spiderman/index';

export default {
  setup() {
    const page = ref('signUp');
    const memberInfo = reactive({
      twid: '',
      birthdate: '',
      mobile: '',
      bindingCode: '',
      password: '',
    });
    const router = useRouter();

    async function sendBindingCode() {
      try {
        spiderman.form.verify(memberInfo);
        memberInfo.birthdate = spiderman.moment(memberInfo.birthdate).format('YYYY-MM-DD');

        composable.loading.show('傳送驗證碼中，請稍候');

        const response = await api.membership.bind(
          composable.member, memberInfo,
        );
        beginCountDown();

        composable.modal.popup(response.message);
      } catch (error) {
        composable.modal.alert(error);
      } finally {
        composable.loading.close();
      }
    }

    const countDownSeconds = ref(0);

    function beginCountDown() {
      countDownSeconds.value = 60;
    }

    watch(countDownSeconds,
      (nextSecond) => {
        if (nextSecond > 0) {
          setTimeout(() => {
            countDownSeconds.value = nextSecond - 1;
          }, 1000);
        }
      });

    async function verifyMemberShip() {
      try {
        spiderman.form.verify(memberInfo);
        memberInfo.birthdate = spiderman.moment(memberInfo.birthdate).format('YYYY-MM-DD');

        composable.loading.show('會員申請中，請稍候');

        const response = await api.membership.verify(
          composable.member, memberInfo,
        );

        composable.modal.show({
          body: response.message,
          hasCloseButton: false,
          footer: [
            { content: '前往登入頁面', type: 'primary', onClickEmit: 'toLogin' },
          ],
        });
      } catch (error) {
        composable.modal.alert(error);
      } finally {
        composable.loading.close();
      }
    }

    function toLogin() {
      composable.modal.close();
      router.push({ path: '/member/login' });
    }

    return {
      page,
      composable,
      memberInfo,
      countDownSeconds,
      sendBindingCode,
      verifyMemberShip,
      toLogin,
    };
  },
};
</script>
